import React from "react";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import { FormattedMessage } from "react-intl";
import Skeleton from "@mui/material/Skeleton";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow
} from "@mui/material";
import { formatDateTime } from "../../../../utils/formatter/dateTimeFormatter";
const ActivityLogsTable = (props) => {
  const {
    className,
    tasks,
    handlePageChange,
    handleRowsPerPageChange,
    page,
    rowsPerPage,
    totalCount,
    loading,
    disableCard,
    paging
  } = props;
  const table = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement(TableHead, null, /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.activityLogs.user" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.activityLogs.action" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.activityLogs.date" })))), /* @__PURE__ */ React.createElement(TableBody, null, loading && new Array(rowsPerPage).fill((index) => index).map((value, index) => /* @__PURE__ */ React.createElement(TableRow, { key: index }, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)))), !loading && tasks.length === 0 && /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, { colSpan: 3 }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.activityLogs.noLogsFound" }))), !loading && tasks.length > 0 && tasks.map((log) => /* @__PURE__ */ React.createElement(TableRow, { key: log.mongoId }, /* @__PURE__ */ React.createElement(TableCell, null, log.userEmail), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: `connections.activityLogs.actions.${log.action}` })), /* @__PURE__ */ React.createElement(TableCell, null, formatDateTime(log.createdAt)))))));
  if (disableCard) {
    return table;
  }
  return /* @__PURE__ */ React.createElement(Card, { className }, /* @__PURE__ */ React.createElement(CardContent, { sx: { padding: 0 } }, /* @__PURE__ */ React.createElement(PerfectScrollbar, null, /* @__PURE__ */ React.createElement(Box, { sx: { verticalAlign: "middle" } }, table))), paging && /* @__PURE__ */ React.createElement(CardActions, { sx: { justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
    TablePagination,
    {
      component: "div",
      count: totalCount,
      onPageChange: handlePageChange,
      onRowsPerPageChange: handleRowsPerPageChange,
      page,
      rowsPerPage,
      rowsPerPageOptions: [5, 10, 25, 50, 100, 1e3]
    }
  )));
};
ActivityLogsTable.propTypes = {
  className: PropTypes.string,
  paging: PropTypes.bool,
  tasks: PropTypes.array.isRequired
};
ActivityLogsTable.defaultProps = {
  paging: true,
  className: ""
};
export default ActivityLogsTable;
